<template>
    <div>
        <date-picker v-model="selectedDate" :popover="{ visibility: 'click' }" :is-range="false">
            <template v-slot="{ inputEvents }">
                <div ref="container" class="relative">
                    <input
                        class="w-full block pl-8 pr-6 bg-transparent input"
                        :value="formattedDate"
                        v-on="inputEvents"
                        :placeholder="placeholder"
                        readonly
                    />

                    <div class="absolute top-0 left-0 h-full flex items-center ml-2">
                        <alo-icon icon="outline-calendar" class="w-4 h-4" />
                    </div>

                    <div class="absolute top-0 right-0 mr-2 h-full flex items-center">
                        <button type="button" v-show="selectedDate" class="p-1" @click="clear()">
                            <alo-icon icon="outline-x" class="w-4 h-4 text-gray-600" />
                        </button>
                    </div>
                </div>
            </template>
        </date-picker>
    </div>
</template>

<script>
import * as Form from '@App/Utils/Form'
import { formatarDataAmigável, formatarDataUtc, formatarISO, utcParaLocal } from '@Shared/Date'
const VCalendar = () => import(/* webpackChunkName: "vcalendar-datepicker" */ '@App/Vendor/VCalendar')

export default {
    components: {
        DatePicker: () => {
            return VCalendar().then((modules) => {
                return modules.DatePicker
            })
        },
    },
    props: ['value', 'field'],
    watch: {
        selectedDate(value) {
            if (value) {
                this.$emit('input', formatarDataUtc(value))
            } else {
                this.$emit('input', null)
            }
        },
    },
    computed: {
        formattedDate() {
            if (this.selectedDate) {
                return formatarDataAmigável(this.selectedDate)
            }
        },
        placeholder() {
            return Form.placeholder(this.field)
        },
    },
    data() {
        return {
            selectedDate: this.value ? utcParaLocal(this.value) : null,
        }
    },
    methods: {
        clear() {
            this.selectedDate = null
        },
    },
}
</script>
